import { createContext, useContext } from 'react';

import ErrorProps from 'design-system/types/ErrorProps';

export interface FormControlContextProps extends ErrorProps {
  inputId?: string;
  helperTextId?: string;
  errorTextId?: string;
  warningTextId?: string;
  labelId?: string;
  disabled?: boolean;
  maxLength?: number;
}

export const FormControlContext = createContext<FormControlContextProps>({});

const useFormField = (props: Partial<FormControlContextProps>) => {
  const field = useContext(FormControlContext);

  const inputId = props.inputId ?? field.inputId;

  return {
    hasError: props.hasError ?? field.hasError,
    hasWarning: props.hasWarning ?? field.hasWarning,
    inputId,
    helperTextId: props.helperTextId ?? field.helperTextId,
    errorTextId: props.errorTextId ?? field.errorTextId,
    warningTextId: props.warningTextId ?? field.warningTextId,
    labelId: props.labelId ?? field.labelId,
    disabled: props.disabled ?? field.disabled,
    maxLength: props.maxLength ?? field.maxLength,
  };
};

export default useFormField;
